import React, { useState, useEffect } from 'react'
import DatePicker from 'rsuite/DatePicker'
import startOfMonth from 'date-fns/startOfMonth'
import endOfMonth from 'date-fns/endOfMonth'
import isBefore from 'date-fns/isBefore'
import 'rsuite/dist/rsuite.min.css'
import './DateRangeCalendar.scss'

const DateRangeCalendar = ({ onChange, from = null, to = null }) => {

    const [firstDate, setFirstDate] = useState(from)
    const [secondDate, setSecondDate] = useState(to)

    const handleChangeFirstDate = (date) => {
        if (date) {
            setFirstDate(startOfMonth(date))
        }
    }

    const handleChangeSecondDate = (date) => {
        if (date) {
            var endOfMonthDate = endOfMonth(date);
            var eomNoTime = new Date(endOfMonthDate.valueOf() - endOfMonthDate.getTimezoneOffset() * 60 * 1000);
            setSecondDate(eomNoTime)
        }
    }

    const onResetFirst = () => {
        setFirstDate(null)
    }

    const onResetSecond = () => {
        setSecondDate(null)
    }

    useEffect(() => {
        onChange([firstDate, secondDate])
    }, [firstDate, secondDate, onChange]) 

    return (
        <div className="d-flex align-items-center">
            <p className="date-picker-text">From: </p>
            <DatePicker value={from!==null?startOfMonth(from):null} placeholder="From" format="yyyy - MMM" className="date-picker w-50" onClean={onResetFirst} onChange={handleChangeFirstDate} oneTap />
            <p className="date-picker-text to">To: </p>
            <DatePicker value={to!==null?endOfMonth(to):null} placeholder="To" format="yyyy - MMM" className="date-picker second-date-picker w-50" onClean={onResetSecond} shouldDisableDate={date => isBefore(date, firstDate)} oneTap onChange={handleChangeSecondDate} />
        </div>
    )
}

export default DateRangeCalendar
